export default __webpack_public_path__ + "static/media/left-column-image.6b9ed4c9.jpg";